var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAssortment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "-2 -6 18 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "noun_collection_2279994") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GlobalNav/CreateNewFlyout-Copy",
    transform: "translate(-20.000000, -164.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(20.000000, 19.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_collection_2279994",
    transform: "translate(0.000000, 145.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5,16 C0.224,16 0,15.775 0,15.5 L0,8.5 C0,8.223 0.224,8 0.5,8 L15.5,8 C15.776,8 16,8.223 16,8.5 L16,15.5 C16,15.775 15.776,16 15.5,16 L0.5,16 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5,6 C1.224,6 1,5.775 1,5.5 L1,4.5 C1,4.223 1.224,4 1.5,4 L14.5,4 C14.776,4 15,4.223 15,4.5 L15,5.5 C15,5.775 14.776,6 14.5,6 L1.5,6 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5,2 C2.224,2 2,1.775 2,1.5 L2,0.5 C2,0.223 2.224,0 2.5,0 L13.5,0 C13.776,0 14,0.223 14,0.5 L14,1.5 C14,1.775 13.776,2 13.5,2 L2.5,2 Z",
    id: "Path"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssortment);
export default __webpack_public_path__ + "static/media/Assortment.78a5b00dea2aa6ed1462e4bcad502c6a.svg";
export { ForwardRef as ReactComponent };